import i18n from "src/i18n";

export const DEFAULT_NUMBER_PRECISION = 2;

export class NumberFormat {
    public static formatUserFacingNumber(numberOpts: { value: number | null; precision?: number }): string | null {
        const { value, precision } = numberOpts || {};
        if (value === null) {
            return null;
        }

        const options: Intl.NumberFormatOptions = {
            minimumFractionDigits: precision ?? DEFAULT_NUMBER_PRECISION,
        };

        const newValue = new Intl.NumberFormat(i18n.resolvedLanguage, options).format(value);

        return newValue;
    }
}
